module.exports = __webpack_public_path__ + "static/Tile2-infrared-f97727ddbb16f59dc565b23b66b6b9cd.gif";